import AApplicationCompleteSign from './index.vue';

AApplicationCompleteSign.install = app => {
  app.component(AApplicationCompleteSign.name, AApplicationCompleteSign);
};

export default AApplicationCompleteSign;
